import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

const PromptCardSkeleton = () => {
  return (
    <Card className="h-full flex flex-col rounded-lg">
      <CardHeader className="grow">
        <div className="space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </CardHeader>
      <CardContent className="grow">
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-3/4" />
      </CardContent>
      <CardFooter className="flex flex-row justify-between">
        <div className="flex flex-wrap gap-2 items-center">
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-6 w-20 rounded-full" />
          <Skeleton className="h-6 w-14 rounded-full" />
        </div>
        <div className="flex">
          <Skeleton className="h-8 w-20" />
        </div>
      </CardFooter>
    </Card>
  );
};

export default PromptCardSkeleton;
